import { useLocalObservable } from "mobx-react-lite";
import React from "react";

import { CommandMenuStore } from "./command-menu-store";

import { CommandMenu } from ".";

const CommandMenuContext = React.createContext<CommandMenuStore | null>(null);

export const useCommandMenuStore = () => {
  const context = React.useContext(CommandMenuContext);
  if (!context) {
    throw new Error("useCommandMenuStore must be used within CommandMenuProvider");
  }
  return context;
};

interface CommandMenuProviderProps {
  children: React.ReactNode;
}

export const CommandMenuProvider: React.FC<CommandMenuProviderProps> = ({ children }) => {
  const store = useLocalObservable(() => new CommandMenuStore());

  React.useEffect(() => {
    // Set up keyboard listeners when component mounts
    store.setupKeyboardListeners();

    return () => {
      store.destroy();
    };
  }, [store]);

  return (
    <CommandMenuContext.Provider value={store}>
      <CommandMenu />
      {children}
    </CommandMenuContext.Provider>
  );
};
